(() => {
  const root = document.getElementById('AbastikDeliveryGate');
  if (!root) return;

  const methodStep = root.querySelector('[data-abastik-step="method"]');
  const deliveryStep = root.querySelector('[data-abastik-step="delivery"]');
  const addressForm = root.querySelector('[data-abastik-address-form]');
  const addressInput = root.querySelector('[data-abastik-address-input]');
  const autocompleteHost = root.querySelector('[data-abastik-autocomplete-host]');
  const addressHint = root.querySelector('[data-abastik-address-hint]');
  const communeSelect = root.querySelector('[data-abastik-commune]');
  const zipInput = root.querySelector('[data-abastik-zip]');
  const status = root.querySelector('[data-abastik-status]');
  const continueButton = root.querySelector('[data-abastik-continue]');
  const googleKey = (root.dataset.googleMapsKey || '').trim();
  const cartUrl = root.dataset.cartUrl || '/cart';
  const allowedCommunes = (root.dataset.allowedCommunes || 'Copiapó, Tierra Amarilla')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);

  const state = {
    trigger: null,
    form: null,
    bypassSubmit: false,
    googleReady: false,
    selectedPlace: null,
    parsedAddress: null,
  };

  const normalize = (value = '') => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const allowedMap = new Map(allowedCommunes.map((name) => [normalize(name), name]));

  function populateCommunes() {
    allowedCommunes.forEach((commune) => {
      const option = document.createElement('option');
      option.value = commune;
      option.textContent = commune;
      communeSelect.appendChild(option);
    });
  }

  function setStatus(type, message) {
    status.className = 'abastik-delivery-gate__status';
    if (!message) {
      status.hidden = true;
      status.textContent = '';
      return;
    }
    status.hidden = false;
    status.classList.add(`is-${type}`);
    status.textContent = message;
  }

  function showStep(name) {
    const delivery = name === 'delivery';
    methodStep.hidden = delivery;
    deliveryStep.hidden = !delivery;
    if (delivery) {
      setTimeout(() => {
        const focusTarget = root.querySelector('gmp-place-autocomplete') || addressInput;
        focusTarget?.focus?.();
      }, 50);
    }
  }

  function openGate(trigger) {
    state.trigger = trigger || null;
    state.form = trigger?.form || document.querySelector('#cart-form') || null;
    showStep('method');
    setStatus('', '');
    root.hidden = false;
    document.body.classList.add('abastik-delivery-gate-open');
    root.querySelector('[data-abastik-method="delivery"]')?.focus();
  }

  function closeGate() {
    root.hidden = true;
    document.body.classList.remove('abastik-delivery-gate-open');
    state.trigger?.focus?.();
  }

  function proceedNativeCheckout() {
    closeGate();
    state.bypassSubmit = true;
    if (state.form && state.trigger && typeof state.form.requestSubmit === 'function') {
      state.form.requestSubmit(state.trigger);
      setTimeout(() => { state.bypassSubmit = false; }, 1000);
      return;
    }
    window.location.assign('/checkout');
  }

  function component(place, wantedTypes) {
    const components = place?.addressComponents || place?.address_components || [];
    const wanted = Array.isArray(wantedTypes) ? wantedTypes : [wantedTypes];
    const found = components.find((item) => {
      const types = item.types || [];
      return wanted.some((type) => types.includes(type));
    });
    if (!found) return '';
    return found.longText || found.long_name || found.shortText || found.short_name || '';
  }

  function matchAllowedCommune(value) {
    const normalized = normalize(value);
    if (allowedMap.has(normalized)) return allowedMap.get(normalized);
    for (const [key, canonical] of allowedMap.entries()) {
      if (normalized.includes(key) || key.includes(normalized)) return canonical;
    }
    return '';
  }

  function parseGooglePlace(place) {
    const admin3 = component(place, 'administrative_area_level_3');
    const locality = component(place, ['locality', 'postal_town']);
    const sublocality = component(place, ['sublocality_level_1', 'sublocality']);
    const commune = matchAllowedCommune(admin3) || matchAllowedCommune(locality) || matchAllowedCommune(sublocality);
    const detectedCommune = admin3 || locality || sublocality;
    const route = component(place, 'route');
    const streetNumber = component(place, 'street_number');
    const postalCode = component(place, 'postal_code');
    const region = component(place, 'administrative_area_level_1') || 'Atacama';
    const country = component(place, 'country') || 'Chile';
    const formatted = place?.formattedAddress || place?.formatted_address || '';
    const address1 = [route, streetNumber].filter(Boolean).join(' ').trim() || formatted.split(',')[0].trim();

    return {
      address1,
      commune,
      detectedCommune,
      zip: postalCode,
      province: region,
      country,
      formatted,
    };
  }

  function validateGooglePlace(place) {
    const parsed = parseGooglePlace(place);
    state.parsedAddress = parsed;

    if (!parsed.address1) {
      setStatus('error', 'No pudimos identificar una calle y número. Selecciona una dirección completa de la lista.');
      continueButton.disabled = true;
      return;
    }

    if (!parsed.commune) {
      const detected = parsed.detectedCommune ? ` Detectamos “${parsed.detectedCommune}”.` : '';
      communeSelect.value = '';
      setStatus('error', `Esta dirección está fuera de nuestra cobertura actual.${detected} Por ahora solo despachamos en ${allowedCommunes.join(' y ')}.`);
      continueButton.disabled = true;
      return;
    }

    communeSelect.value = parsed.commune;
    if (parsed.zip) zipInput.value = parsed.zip;
    setStatus('success', `✓ Dirección disponible para despacho en ${parsed.commune}.`);
    continueButton.disabled = false;
  }

  async function loadGooglePlaces() {
    if (!googleKey) {
      setStatus('info', `Selecciona manualmente tu comuna. La validación automática por buscador se puede activar desde el editor del tema agregando una clave de Google Maps.`);
      return;
    }

    try {
      if (!window.google?.maps) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(googleKey)}&loading=async&libraries=places&v=weekly&language=es&region=CL`;
          script.async = true;
          script.onerror = reject;
          script.onload = resolve;
          document.head.appendChild(script);
        });
      }

      const { PlaceAutocompleteElement } = await google.maps.importLibrary('places');
      const autocomplete = new PlaceAutocompleteElement({});
      autocomplete.id = 'AbastikGoogleAddress';
      autocomplete.placeholder = 'Busca tu calle y número';
      autocomplete.includedRegionCodes = ['cl'];
      autocomplete.locationBias = { center: { lat: -27.37, lng: -70.33 }, radius: 50000 };

      addressInput.hidden = true;
      autocompleteHost.appendChild(autocomplete);
      communeSelect.disabled = true;
      addressHint.textContent = 'Selecciona una dirección de la lista para validar la comuna automáticamente.';
      continueButton.disabled = true;
      state.googleReady = true;

      autocomplete.addEventListener('gmp-select', async (event) => {
        try {
          const place = event.placePrediction.toPlace();
          await place.fetchFields({ fields: ['formattedAddress', 'addressComponents', 'location'] });
          state.selectedPlace = place;
          validateGooglePlace(place);
        } catch (error) {
          console.warn('[ABASTIK] No se pudo validar la dirección seleccionada', error);
          setStatus('error', 'No pudimos validar esa dirección. Intenta seleccionarla nuevamente.');
          continueButton.disabled = true;
        }
      });
    } catch (error) {
      console.warn('[ABASTIK] Google Places no pudo iniciarse; usando validación manual.', error);
      addressInput.hidden = false;
      communeSelect.disabled = false;
      state.googleReady = false;
      setStatus('info', 'El buscador automático no está disponible en este momento. Puedes continuar ingresando la dirección y seleccionando la comuna manualmente.');
    }
  }

  function buildCheckoutParams(data) {
    const params = new URLSearchParams();
    params.set('checkout[shipping_address][address1]', data.address1);
    if (data.address2) params.set('checkout[shipping_address][address2]', data.address2);
    params.set('checkout[shipping_address][city]', data.commune);
    params.set('checkout[shipping_address][province]', data.province || 'Atacama');
    params.set('checkout[shipping_address][country]', data.country || 'Chile');
    if (data.zip) params.set('checkout[shipping_address][zip]', data.zip);
    return params;
  }

  function proceedDeliveryCheckout(data) {
    try {
      sessionStorage.setItem('abastik_delivery_address', JSON.stringify({
        address1: data.address1,
        address2: data.address2 || '',
        commune: data.commune,
        zip: data.zip || '',
        savedAt: Date.now(),
      }));
    } catch (_) {}

    const params = buildCheckoutParams(data);
    const separator = cartUrl.includes('?') ? '&' : '?';
    const actionWithPrefill = `${cartUrl}${separator}${params.toString()}`;

    if (state.form && state.trigger) {
      const originalAction = state.form.getAttribute('action');
      state.form.setAttribute('action', actionWithPrefill);
      state.bypassSubmit = true;
      closeGate();
      state.form.requestSubmit(state.trigger);
      setTimeout(() => {
        state.bypassSubmit = false;
        if (originalAction !== null) state.form.setAttribute('action', originalAction);
        else state.form.removeAttribute('action');
      }, 1200);
      return;
    }

    window.location.assign(`/checkout?${params.toString()}`);
  }

  function restoreLastAddress() {
    try {
      const saved = JSON.parse(sessionStorage.getItem('abastik_delivery_address') || 'null');
      if (!saved || Date.now() - Number(saved.savedAt || 0) > 1000 * 60 * 60 * 4) return;
      if (!state.googleReady && saved.address1) addressInput.value = saved.address1;
      const matched = matchAllowedCommune(saved.commune || '');
      if (matched) communeSelect.value = matched;
      const address2 = root.querySelector('#AbastikAddress2');
      if (address2 && saved.address2) address2.value = saved.address2;
      if (saved.zip) zipInput.value = saved.zip;
    } catch (_) {}
  }

  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkoutButton || !checkoutButton.form || state.bypassSubmit) return;
    event.preventDefault();
    event.stopPropagation();
    openGate(checkoutButton);
  }, true);

  document.addEventListener('submit', (event) => {
    if (state.bypassSubmit) return;
    const submitter = event.submitter;
    const isCheckout = submitter?.name === 'checkout' || submitter?.id === 'checkout';
    if (!isCheckout) return;
    event.preventDefault();
    event.stopPropagation();
    openGate(submitter);
  }, true);

  root.addEventListener('click', (event) => {
    if (event.target.closest('[data-abastik-close]')) {
      closeGate();
      return;
    }
    if (event.target.closest('[data-abastik-back]')) {
      showStep('method');
      return;
    }
    const method = event.target.closest('[data-abastik-method]')?.dataset.abastikMethod;
    if (method === 'pickup') {
      proceedNativeCheckout();
      return;
    }
    if (method === 'delivery') {
      showStep('delivery');
      restoreLastAddress();
    }
  });

  addressForm.addEventListener('submit', (event) => {
    event.preventDefault();
    setStatus('', '');

    if (state.googleReady) {
      if (!state.parsedAddress?.commune || !state.parsedAddress?.address1) {
        setStatus('error', 'Selecciona una dirección válida desde el buscador para comprobar la cobertura.');
        return;
      }
      proceedDeliveryCheckout({
        ...state.parsedAddress,
        address2: root.querySelector('#AbastikAddress2')?.value.trim() || '',
        zip: zipInput.value.trim() || state.parsedAddress.zip || '',
      });
      return;
    }

    const address1 = addressInput.value.trim();
    const commune = matchAllowedCommune(communeSelect.value);
    if (address1.length < 5) {
      setStatus('error', 'Ingresa una dirección válida con calle y número.');
      addressInput.focus();
      return;
    }
    if (!commune) {
      setStatus('error', `Por ahora solo despachamos en ${allowedCommunes.join(' y ')}.`);
      communeSelect.focus();
      return;
    }

    setStatus('success', `✓ Dirección habilitada para despacho en ${commune}.`);
    proceedDeliveryCheckout({
      address1,
      address2: root.querySelector('#AbastikAddress2')?.value.trim() || '',
      commune,
      zip: zipInput.value.trim(),
      province: 'Atacama',
      country: 'Chile',
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) closeGate();
  });

  populateCommunes();
  loadGooglePlaces();
})();
